const VIPSonkoLandingPage = () => import('./index.vue')
const VIPExpertPortfolio = () => import('./_components/portfolio.vue')
const VIPExpertJobAssigned = () => import('./_components/expert_jobassigned.vue')
import { EngageExpertGuard, CheckVIPSonkoGuard } from '@/common/guard'

export default [
    {
        path: '/vip_sonko/landing',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPSonkoLandingPage,
        name: 'VIPSonkoLandingPage'
    },
    {
        path: '/vip_sonko/expert/portfolio/:id',
        beforeEnter: EngageExpertGuard,
        component: VIPExpertPortfolio,
        name: 'VIPExpertPortfolio'
    },
    {
        path: '/vip_sonko/expert/jobs/assigned/:id',
        beforeEnter: EngageExpertGuard,
        component: VIPExpertJobAssigned,
        name: 'VIPExpertJobAssigned'
    }
]